import { Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './PlannerHeader.module.css';

const MasterDataMenu = () => {
  const navStyle = ({ isActive }) => (isActive ? classes.navActive : classes.navStyle);

  return (
    <NavLink to='master-data' className={navStyle}>
      <Typography variant='s16_w600'>Master Data</Typography>
    </NavLink>
  );
};

export default MasterDataMenu;
